import React from "react";

const PALETTE = {
  dark: { word: "#F5F2EB", sub: "#A79E93" },
  light: { word: "#14110E", sub: "#4A3D30" },
};
const DOT = "#F64F09";
const LION = "#F82D09";
const SUB = "INTERNATIONAL INC";

// Lion mark + orange divider + two-line "Trafalgar." wordmark. `size` = wordmark font-size in px.
export function Logo({ variant = "light", size = 30, className = "", dataTestId = "brand-logo" }) {
  const c = PALETTE[variant] || PALETTE.light;
  const blockH = Math.round(size * 1.36);
  return (
    <span
      role="img"
      aria-label="Trafalgar International Inc"
      className={`inline-flex items-center select-none leading-none ${className}`}
      style={{ gap: size * 0.36 }}
      data-testid={dataTestId}
    >
      <img
        src="/assets/trafalgar-lion.png?v=1"
        alt=""
        aria-hidden="true"
        draggable={false}
        style={{ height: blockH, width: "auto", background: "transparent" }}
        className="block shrink-0"
        data-testid={`${dataTestId}-lion`}
      />
      <span aria-hidden="true" className="block shrink-0" style={{ width: 1.5, height: blockH, background: LION }} />
      <span aria-hidden="true" className="inline-grid">
        <span
          className="font-display font-bold tracking-[-0.02em] whitespace-nowrap"
          style={{ fontSize: size, color: c.word, lineHeight: 0.95 }}
        >
          Trafalgar<span style={{ color: DOT }}>.</span>
        </span>
        <span
          className="flex justify-between font-mono font-medium w-0 min-w-full"
          style={{ fontSize: Math.max(7, size * 0.25), color: c.sub, marginTop: size * 0.16, paddingRight: size * 0.28 }}
        >
          {SUB.split("").map((ch, i) => (
            <span key={i}>{ch === " " ? "\u00A0" : ch}</span>
          ))}
        </span>
      </span>
    </span>
  );
}

export default Logo;
